import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/ordem/ordens_servico${queryUrl}`)
  },
  insert(data) {
    return axios.post('/ordem/ordens_servico/', data)
  },
  edit(data) {
    return axios.put(`/ordem/ordens_servico/${data.id}`, data)
  },
  delete(id) {
    return axios.put(`/ordem/ordens_servico/${id}`)
  },
  getById(id) {
    return axios.get(`/ordem/ordens_servico/${id}`)
  },
  searchRegistros(name) {
    const endpoint = `/atendimento/profissionais/registro?nome=${name}&page=0&size=10&sort=id,asc`
    return axios.get(endpoint)
  }
}
